<div *ngIf="isVisible" class="driver-list-lite-container  left-first-level-container" [@openClose]>

  <div class="p-4 flex justify-between align-middle">
    <span class="font-semibold text-xl">{{'worker.title' | translate}}</span>
    <app-close-button class="self-center" (close)="onClose()"></app-close-button>
  </div>

  <mat-form-field [formGroup]="form" appearance="outline" class="rounded-xl text-xs px-4" hideRequiredMarker>
    <mat-label>{{'labels.search' | translate | titlecase}}</mat-label>
    <div matPrefix class="tk-i-search-black w-4 h-4 mr-2"></div>
    <input matInput class="" type="text" formControlName="search" autocomplete="false" maxlength="25">
  </mat-form-field>

  <mat-tab-group animationDuration="0ms" class="grow h-full " (selectedIndexChange)="onSelectedTabChanged()">
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="bg-white text-black text-xs">
          {{'worker.active' | translate}} ({{driversCount}})
        </div>
      </ng-template>
      <div class="h-full tk-bg-gray-5 overflow-hidden">

        <div *ngIf="!this.isLoadingWorkers && hasAnyDrivers"
             class="flex flex-col align-middle pl-4 pr-2 my-2 tk-bg-gray-5">

          <app-button *ngIf="isNewDriverButtonVisible" [isActive]="true" [isFullWidth]="true"
                      innerTextClasses="text-sm"
                      spinnerClasses="my-1.5" label="{{'worker.add' | translate}}"
                      (click)="onAddDriver()"></app-button>

          <div *ngIf="!isNewDriverButtonVisible" class="font-semibold text-xs text-center py-1.5">
            {{'worker.first-save' | translate}}
          </div>
        </div>

        <div *ngIf="isLoadingWorkers; else addDriverTemp" style="height: calc(100vh - 180px)"
             class="grid place-items-center">
          <div class="flex flex-col ">
            <div class="flex justify-center">
              <mat-spinner [strokeWidth]="2" [diameter]="40" color="primary"></mat-spinner>
            </div>
            <div class="mt-2">{{'labels.loading-data' | translate}}</div>
          </div>
        </div>
        <ng-template #addDriverTemp>
          <div *ngIf="!hasAnyDrivers" style="height: calc(100vh - 180px)"
               class="bg-white flex flex-col justify-center">
            <div class="tk-i-no-worker w-full h-36"></div>
            <div class="mt-3 flex justify-center">
              <span class="font-semibold">{{'worker.not-added-yet' | translate}}</span>
            </div>
          </div>
        </ng-template>

        <cdk-virtual-scroll-viewport itemSize="96" minBufferPx="100" maxBufferPx="100"
                                     style="height: calc(100vh - 225px)">
          <div #workersList *cdkVirtualFor="let driver of displayedDrivers" class="ml-4 mr-2 my-2 h-24"
               (click)="onSelect(driver)">
            <wm-driver-list-item [driver]="driver" [isSelected]="isItemSelected(driver)"></wm-driver-list-item>
          </div>
        </cdk-virtual-scroll-viewport>

      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="bg-white text-black text-xs">
          {{'worker.archive' | translate}} ({{archiveWorkersCount}})
        </div>
      </ng-template>

      <div class="h-full tk-bg-gray-5 overflow-hidden">

        <div *ngIf="isLoadingArchiveDrivers; else noArchiveDriversTemp"
             class="grid place-items-center h-screen">
          <div class="flex flex-col grow">
            <div class="flex justify-center">
              <mat-spinner [strokeWidth]="2" [diameter]="40" color="primary"></mat-spinner>
            </div>
            <div class="mt-2">{{'labels.loading-data' | translate}}</div>
          </div>
        </div>
        <ng-template #noArchiveDriversTemp>
          <div *ngIf="hasAnyArchiveDrivers" style="height: calc(100vh - 180px)"
               class="bg-white flex flex-col justify-center">
            <div class="tk-i-no-worker w-full h-36"></div>
            <div class="mt-3 flex justify-center">
              <span class="font-semibold">{{'worker.no-archive-yet' | translate}}</span>
            </div>
          </div>
        </ng-template>

        <cdk-virtual-scroll-viewport itemSize="40" minBufferPx="750" maxBufferPx="750"
                                     style="height: calc(100vh - 175px)">
          <div *cdkVirtualFor="let driver of displayedArchiveWorkers" class="ml-4 mr-2 my-2 h-10"
               (click)="onSelect(driver)">
            <wm-driver-list-item [driver]="driver" [isSelected]="isItemSelected(driver)"></wm-driver-list-item>
          </div>
        </cdk-virtual-scroll-viewport>

      </div>

    </mat-tab>

  </mat-tab-group>

</div>
